import { getTestAttributes } from '@chillibean/component-library';
import { NavLink, useRouteMatch } from 'react-router-dom';

export function Sidebar() {
  const { url } = useRouteMatch();
  return (
    <div id="template-builder_sidebar">
      <li {...getTestAttributes('form-templates-link')}>
        <NavLink activeClassName="active" to={url} exact>
          Form Templates
        </NavLink>
      </li>
      <li {...getTestAttributes('active-form-templates-link')}>
        <NavLink activeClassName="active" to={`${url}active`}>
          Active Form Templates
        </NavLink>
      </li>
      <div id="template-builder_divider">
        <hr />
      </div>
      <li {...getTestAttributes('inactive-form-templates-link')}>
        <NavLink activeClassName="active" to={`${url}inactive`}>
          Inactive Form Templates
        </NavLink>
      </li>
    </div>
  );
}

export default Sidebar;
